define('lq/visibility/itemVisibility',[
    './defaultVisibility'
], function (DefaultVisibility) {
    'use strict';

    var ItemVisibility = function (dataRow, parent) {
        this.dataRow = dataRow;
        this.parent = parent;
        this.default = new DefaultVisibility();
    };

    ItemVisibility.prototype.apply = function (drop) {
        if (this.shouldGetVisibilityFromParent(drop)) {
            drop.addListener('DatasourceApplied', this.updateVisibilityFromDataRow.bind(this, drop))
        } else {
            this.default.apply(drop);
        }
    };

    ItemVisibility.prototype.updateVisibilityFromDataRow = function (drop) {
        var isVisible = this.dataRow[drop.data.dataSourceOutputForVisibility];

        if (isVisible)
            drop.showWithoutAnimation();
        else
            drop.hideWithoutAnimation();
    };

    ItemVisibility.prototype.shouldGetVisibilityFromParent = function (drop) {
        if (drop.data.initialVisibilityOption !== 'From Query')
            return false;
        return drop.data.dataSourceForVisibility === this.parent.data.dataSource || this.parent.data.useParentGroupData;
    };

    return ItemVisibility;
});
